import React, { useEffect, useState } from 'react';

import { VbzModal } from '@smiles/voebiz-ui-kit';

import ModalUpgradeBody from '../ModalUpgradeBody';
import ModalDowngradeBody from '../ModalDowngradeBody';
import ModalMaintenanceBody from '../ModalMaintenanceBody';

type UpdateModalT = {
  isOpen: boolean;
  modalType: string;
  nextTier?: string;
  tier?: string;
  handleClose: (bol: boolean) => void;
};

function UpdateModal({ isOpen, modalType, nextTier, tier, handleClose }: UpdateModalT) {
  const [isUpgrade, setIsUpgrade] = useState(true);
  const [isDowngrade, setIsDowngrade] = useState(false);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [previousTier, setPreviousTier] = useState<string | undefined>(undefined);

  useEffect(() => {
    // eslint-disable-next-line no-shadow
    const getPreviousTier = (nextTier: string | undefined): string | undefined => {
      const voeBizCategories = ['voebiz', 'Essencial', 'Prime', 'Super Prime'];
      if (nextTier) {
        const index = voeBizCategories.indexOf(nextTier);
        if (index > 0) {
          return voeBizCategories[index - 1];
        }
      }
      return undefined;
    };

    setPreviousTier(getPreviousTier(nextTier));
  }, [nextTier]);

  const handleModalClose = () => {
    setIsUpgrade(false);
    setIsDowngrade(false);
    setIsMaintenance(false);
    handleClose(!isOpen);
  };

  const cookiesName = 'tier-cookies';
  useEffect(() => {
    if (modalType === 'upgrade') {
      setIsUpgrade(true);
      setIsDowngrade(false);
      setIsMaintenance(false);
      localStorage.setItem(cookiesName, 'upgrade');
    }
    if (modalType === 'downgrade') {
      setIsUpgrade(false);
      setIsDowngrade(true);
      setIsMaintenance(false);
      localStorage.setItem(cookiesName, 'downgrade');
    }
    if (modalType === 'maintenance') {
      setIsUpgrade(false);
      setIsDowngrade(false);
      setIsMaintenance(true);
      localStorage.setItem(cookiesName, 'maintenance');
    }
  }, [modalType]);

  return (
    <VbzModal isOpen={isOpen} type="right" desktopSize="small" toggle={handleModalClose}>
      {isUpgrade && <ModalUpgradeBody onClick={handleModalClose} nextTier={nextTier} />}
      {isDowngrade && <ModalDowngradeBody onClick={handleModalClose} previousTier={previousTier} tier={tier} />}
      {isMaintenance && <ModalMaintenanceBody onClick={handleModalClose} tier={tier} />}
    </VbzModal>
  );
}

UpdateModal.defaultProps = {
  nextTier: undefined,
  tier: undefined,
};

export default UpdateModal;
